// Define the slides, with some containing scene-specific content
export const slides = [
    { type: 'image', heading: 'COVER', content: './presentation3/1.jpg' },
    {
      type: 'scene',
      heading: 'GOOGLE',
      content: {
        visibleObjects: ['SATELLITE'],
        cameraPosition: [ 198437,5325 ,-7997897  ],
        lookAt: [198436, 1094,-7998965],
        description:`<strong>OVERVIEW<strong> `
      }
    },
    {
      type: 'scene',
      heading: 'DRONE',
      content: {
        visibleObjects: ['SATELLITE','Bluerock_1K'],
        cameraPosition: [ 198437,5325 ,-7997897  ],
        lookAt: [198436, 1094,-7998965],
        description:`<strong>OVERVIEW<strong> `
      }
    },
    // {
    //   type: 'scene',
    //   heading: 'DroneA',
    //   content: {
    //     visibleObjects: ['SATELLITE','Bluerock_1K'],
    //     cameraPosition: [ 198437,5325 ,-7997897  ],
    //     lookAt: [198436, 1094,-7998965],
    //     description:`<strong>OVERVIEW<strong> `
    //   }
    // },
    { type: 'image', heading: 'TARGETS', content: './presentation3/2.jpg' },
    { type: 'image', heading: 'REDHAT', content: './presentation3/Red Hat Presentation_3-13.jpg' },
    { type: 'image', heading: 'BLUEROCK', content: './presentation3/3.jpg' },
    { type: 'image', heading: 'HOLES', content: './presentation3/3a.jpg' },
    { type: 'image', heading: 'HOLES', content: './presentation3/3c.jpg' },
    { type: 'image', heading: 'HOLES', content: './presentation3/3d.jpg' },
    { type: 'image', heading: 'HOLES', content: './presentation3/3e.jpg' },
    { type: 'image', heading: 'HOLES', content: './presentation3/3f.jpg' },
    { type: 'image', heading: 'COMPARISON', content: './presentation3/4.jpg' },
    { type: 'image', heading: 'CROSS', content: './presentation3/5.jpg' },
    { type: 'image', heading: 'PITS', content: './presentation3/6.jpg' },


    {
      type: 'scene',
      heading: 'OREBODY',
      content: {
        visibleObjects: ['orebody_2025'],
        cameraPosition: [ 198437,5325 ,-7997897  ],
        lookAt: [198436, 1094,-7998965],
        description:`<strong>OVERVIEW<strong> `
      }
    },

    {
      type: 'scene',
      heading: 'BLOCKMODEL',
      content: {
        visibleObjects: ['BlockModel'],
        cameraPosition: [ 198437,5325 ,-7997897  ],
        lookAt: [198436, 1094,-7998965],
        description:`<strong>OVERVIEW<strong> `
      }
    },

    {
      type: 'scene',
      heading: 'PITS',
      content: {
        visibleObjects: ['BlockModel','pit1a_design','pit1b_design','pit2_design','pit3_design'],
        cameraPosition: [ 198437,5325 ,-7997897  ],
        lookAt: [198436, 1094,-7998965],
        description:`<strong>OVERVIEW<strong> `
      }
    },



    { type: 'image', heading: 'PIT3', content: './presentation3/8.jpg' },
    { type: 'image', heading: 'PIT3', content: './presentation3/9.jpg' },
    { type: 'image', heading: 'PIT2', content: './presentation3/12.jpg' },
    { type: 'image', heading: 'PIT1', content: './presentation3/13.jpg' },
    { type: 'image', heading: 'PROPOSAL', content: './presentation3/15.jpg' },
    { type: 'image', heading: 'END', content: './presentation3/16.jpg' },

  ];